import React from 'react';

export const name = 'qb';

export const QB = () => (
  <svg viewBox="0 0 24 24" color="#161616" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M14.2688 4.85254H16.6013L15.7463 8.86504H15.9038C16.1739 8.5081 16.5284 8.22389 16.9356 8.03799C17.3427 7.85208 17.7897 7.77031 18.2363 7.80004C20.1188 7.80004 21.3188 9.03754 21.3188 11.19C21.3188 13.59 19.7588 16.2075 16.8938 16.2075C16.4214 16.2655 15.9423 16.1816 15.5176 15.9666C15.093 15.7516 14.7418 15.4151 14.5088 15H14.3588L14.1113 16.05H11.8613L14.2688 4.85254ZM16.5188 14.5275C18.1838 14.5275 19.0388 12.675 19.0388 11.2575C19.0388 10.08 18.4688 9.47254 17.4563 9.47254C15.7838 9.47254 14.9438 11.3175 14.9438 12.735C14.8988 13.9125 15.4838 14.5275 16.4888 14.5275H16.5188Z"
    />
    <path
      fill="currentColor"
      d="M11.2012 19.1475H8.95115V15H8.79365C8.52639 15.3768 8.17197 15.6834 7.7606 15.8937C7.34923 16.1039 6.89312 16.2116 6.43115 16.2075C4.41365 16.2075 2.68115 14.8725 2.68115 12C2.68115 9.12745 4.41365 7.78495 6.43115 7.78495C6.9231 7.77802 7.40854 7.8979 7.84072 8.13304C8.2729 8.36817 8.63724 8.71064 8.89865 9.12745H9.05615V7.94995H11.2386L11.2012 19.1475ZM7.01615 9.47245C5.80865 9.47245 4.88614 10.3425 4.88614 12.0075C4.88614 13.6725 5.80865 14.5275 7.01615 14.5275C8.10365 14.5275 9.01865 13.665 9.01865 12.0075C9.01865 10.35 8.14865 9.47245 7.01615 9.47245V9.47245Z"
    />
  </svg>
);
